import { render, staticRenderFns } from "./ConfigType.vue?vue&type=template&id=2493f3d7&scoped=true"
import script from "./ConfigType.vue?vue&type=script&lang=js"
export * from "./ConfigType.vue?vue&type=script&lang=js"
import style0 from "./ConfigType.vue?vue&type=style&index=0&id=2493f3d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493f3d7",
  null
  
)

export default component.exports